import { useState } from "react";
import { developmentPlaywrightScript } from "../../playwrightScripts";
import {
  useLogs,
  usePlutoFrame,
  useProof,
  useError,
} from "@plutoxyz/react-frame";
const RawFrameTest = () => {
  const [iframeKey, setIframeKey] = useState(0);
  const { isConnected, connect, resetConnection } = usePlutoFrame();
  const logs = useLogs();
  const proof = useProof();
  const error = useError();

  const connectFrame = async () => {
    try {
      await resetConnection();
      setIframeKey((k) => k + 1);
      await connect(developmentPlaywrightScript);
    } catch (error) {
      console.error("Error connecting Pluto Frame:", error);
    }
  };

  return (
    <div className="raw-frame-container" style={{ padding: "20px" }}>
      <h1 style={{ margin: "0 0 16px 0", fontSize: "24px" }}>Raw Frame Test</h1>
      <p style={{ margin: "0 0 24px 0" }}>
        This page shows the Pluto iframe with minimal styling and no UI
        enhancements
      </p>

      <div className="frame-wrapper" style={{ margin: "0 0 20px 0" }}>
        <div
          style={{
            border: "1px dashed #ccc",
            borderRadius: "4px",
            padding: "20px",
            backgroundColor: "#f9f9f9",
          }}
        >
          <div
            id="pluto-frame"
            key={iframeKey}
            style={{ position: "relative", zIndex: 10 }}
          />
        </div>
      </div>

      <button
        onClick={connectFrame}
        style={{
          padding: "8px 16px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          background: "#f0f0f0",
          cursor: "pointer",
        }}
      >
        {isConnected ? "Reconnect Pluto Frame" : "Connect Pluto Frame"}
      </button>
      {proof && (
        <div className="mt-4 p-4 border border-gray-300 rounded-md max-w-md overflow-clip">
          <h3 className="text-lg font-semibold mb-2">Proof</h3>
          <pre className="text-sm overflow-auto bg-gray-50 p-3 rounded-md">
            <div className="flex flex-row gap-2 mb-2">
              <span className="font-semibold text-blue-600">
                {Object.keys(proof.data)[0]}:
              </span>
              <span className="text-gray-800 break-all">
                {Object.values(proof.data)[0]}
              </span>
            </div>
            <div className="text-gray-700 break-all">
              <span className="font-semibold text-blue-600">Signature: </span>
              <span>{proof.signature}</span>
            </div>
          </pre>
        </div>
      )}
      {error && (
        <div className="mt-4 p-4 border border-red-300 rounded-md max-w-md overflow-clip">
          <h3 className="text-lg font-semibold mb-2">Error</h3>
          <pre className="text-sm overflow-auto bg-red-50 p-3 rounded-md">
            <span className="text-red-800">{error.display_message}</span>
            <span className="text-red-800">{error.message}</span>
          </pre>
        </div>
      )}

      <div
        style={{
          marginTop: "20px",
          border: "1px solid #eee",
          borderRadius: "4px",
          padding: "10px",
          backgroundColor: "#fafafa",
          maxHeight: "200px",
          overflow: "auto",
        }}
      >
        <h3 style={{ margin: "0 0 10px 0", fontSize: "16px" }}>Logs:</h3>
        {logs.length === 0 ? (
          <div style={{ color: "#888", fontStyle: "italic" }}>
            No logs yet. Click the button to connect the frame.
          </div>
        ) : (
          <div>
            {logs.map((log, i) => (
              <div
                key={i}
                style={{
                  padding: "4px 0",
                  borderBottom: i < logs.length - 1 ? "1px solid #eee" : "none",
                  color: "#1976d2",
                }}
              >
                {log}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RawFrameTest;
